module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selections-index row"
  }, _vm._l((_vm.selected), function(item, index) {
    return _c('div', {
      staticClass: "selection col col-md-3 col-6"
    }, [_c('div', {
      staticClass: "selections-image"
    }, [(item.imagePath) ? _c('img', {
      attrs: {
        "src": ("/" + (item.imagePath))
      }
    }) : _vm._e()]), _vm._v(" "), (_vm.isAuthorized('selections-edit', _vm.$route.params.id)) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected[index]),
        expression: "selected[index]"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          var $$exp = _vm.selected,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.selected[index] = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          } else {
            $$exp.splice($$idx, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Sorte wählen")]), _vm._v(" "), _vm._l((_vm.selectedOrUnassignedCreams(_vm.selected[index])), function(cream) {
      return _c('option', {
        domProps: {
          "value": cream
        }
      }, [_vm._v("\n        " + _vm._s(cream.name) + "\n      ")])
    })], 2) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65507d1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/frontend/components/pages/selections/_index.vue
// module id = 120
// module chunks = 1